import {
  ActionsObservable,
  StateObservable,
  ofType,
  combineEpics,
} from 'redux-observable';
import { RootAction, RootState } from '@src/app/_redux';
import { IntelliselGetOfferPayload, IntelliselOfferResponsePayload } from '@src/_api/payload/intellisel';
import { ApiClient } from '@src/app/_global/utility/apiUtils';
import { ApiConfig } from '@src/app/_global/domain';
import {
  config as AWSConfig,
  CognitoIdentityCredentials,
} from 'aws-sdk/global';

import {
  INTELLISEL_START,
  actionCreators,
} from './actions';

import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { concat } from 'rxjs/observable/concat';
import { actionCreators as omsActionCreators } from '@src/app/login/oms/actions';
import { actionCreators as authActions } from '@src/app/header/actions';

const intelliselEvents = (
  action$: ActionsObservable<RootAction>,
  state$: StateObservable<RootState>,
) =>
  action$.pipe(
    ofType(INTELLISEL_START),
    mergeMap(({ payload }) => {
      const clientConfig = state$.value.clientConfig.clientConfig;
      AWSConfig.credentials = new CognitoIdentityCredentials(
        state$.value.auth.omsAuth.credentials,
      );

      const loading = of(actionCreators.intelliselLoading(true));

      const client = new ApiClient();
      if (!AWSConfig.region) {
        AWSConfig.region = clientConfig.Region;
      }

      let postBody: IntelliselGetOfferPayload | IntelliselOfferResponsePayload = payload;
      
      const apiConfig: ApiConfig = {
        creds: AWSConfig.credentials as CognitoIdentityCredentials,
        url: clientConfig.url,
        path: '/intellisel',
        region: clientConfig.Region,
        requestmethod: 'POST',
        requestbody: postBody,
        parms: {},
        additionalParms: {
          headers: {
            'x-session-id': clientConfig.uuid
          },
        },
      };

      const source$ = fromPromise(client.callApiGateway(apiConfig)).pipe(
        map(answer => {
          const isSuccess = String(answer.success) === 'true';
          if (isSuccess) {
            return actionCreators.intelliselSuccess({
              success: true,
              transactionCode: payload.intellisel.transactionCode,
              response: answer.intellisels[0].offers,
            });
          } else {
            return actionCreators.intelliselError({
              success: false,
              message: 'Error on Load of Intellisel',
            });
          }
        }),
        catchError(err => {
        // if error msg contains "Invalid login token" then fire logout action with different notifcation.
        if (err && err.message.includes('Invalid login token')) {
          omsActionCreators.omsLookupFailureNotification(
            err ? err.message : 'Session Timeout',
          );
          return of(authActions.userLogout()); 
        } else {
          omsActionCreators.omsLookupFailureNotification(
            err ? err.message : 'Unknown error',
          );
          return of(
            actionCreators.intelliselError({
              success: false,
              message: err,
            }),
          );
        }

        }),
      );

      return concat(loading, source$);
    }),
  );

export const epics = combineEpics(intelliselEvents);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/intellisel/epics.ts